import { useCallback, useState } from "react";
import { useChannel } from "./useChannel";

/**
 * Listens for real-time shift warning broadcasts on the authenticated
 * user's private channel.
 *
 * Returns the latest warning payload and helpers to dismiss or act on it.
 */
export function useShiftWarnings(userId) {
  const [warning, setWarning] = useState(null);

  const handleWarning = useCallback((payload) => {
    setWarning(payload);
  }, []);

  useChannel(
    userId ? `user.${userId}` : null,
    ".shift.warning",
    handleWarning,
  );

  const dismiss = useCallback(() => setWarning(null), []);

  return { warning, dismiss };
}
